/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createSubscriptionResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type SubscriptionResponse } from '../../models/index.js';
// @ts-ignore
import { AddonsRequestBuilderRequestsMetadata, type AddonsRequestBuilder } from './addons/index.js';
// @ts-ignore
import { CancelRequestBuilderRequestsMetadata, type CancelRequestBuilder } from './cancel/index.js';
// @ts-ignore
import { ChangePlanRequestBuilderRequestsMetadata, type ChangePlanRequestBuilder } from './changePlan/index.js';
// @ts-ignore
import { ResumeRequestBuilderRequestsMetadata, type ResumeRequestBuilder } from './resume/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /billing/subscription
 */
export interface SubscriptionRequestBuilder extends BaseRequestBuilder<SubscriptionRequestBuilder> {
    /**
     * The addons property
     */
    get addons(): AddonsRequestBuilder;
    /**
     * The cancel property
     */
    get cancel(): CancelRequestBuilder;
    /**
     * The changePlan property
     */
    get changePlan(): ChangePlanRequestBuilder;
    /**
     * The resume property
     */
    get resume(): ResumeRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SubscriptionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SubscriptionResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SubscriptionRequestBuilderUriTemplate = "{+baseurl}/billing/subscription";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SubscriptionRequestBuilderNavigationMetadata: Record<Exclude<keyof SubscriptionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    addons: {
        requestsMetadata: AddonsRequestBuilderRequestsMetadata,
    },
    cancel: {
        requestsMetadata: CancelRequestBuilderRequestsMetadata,
    },
    changePlan: {
        requestsMetadata: ChangePlanRequestBuilderRequestsMetadata,
    },
    resume: {
        requestsMetadata: ResumeRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SubscriptionRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SubscriptionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSubscriptionResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
